module.exports = __webpack_public_path__ + "img/mobile.e5b18d87.svg";